import PropTypes from 'prop-types'

import { classNames } from '../../helpers'
import { getScoreColorV1 } from '../../helpers/score-color'
import Badge from './Badge'

/**
 * Score-Pill mit datenabgeleiteter Farbe.
 *
 * Der Inline-`style` ist Absicht: die Hex-Werte kommen aus `helpers/score-color`
 * und speisen auch die Matching-Tabelle. Als Tailwind-Arbitrary-Values
 * dupliziert entstuende eine zweite Quelle der Wahrheit.
 *
 * Ohne numerischen Score wird eine graue Badge mit Text gerendert — nicht,
 * wie vorher, eine leere farbige Kapsel.
 */
const ScorePill = ({ score, color, emptyLabel, className }) => {
  if (typeof score !== 'number') {
    return (
      <Badge
        type='basic'
        color='gray'
        text={emptyLabel}
        className={className}
      />
    )
  }

  return (
    <span
      style={{ backgroundColor: color || getScoreColorV1(score) }}
      className={classNames(
        'inline-flex h-8 min-w-16 items-center justify-center rounded-full px-3 text-base font-bold text-white',
        className
      )}
    >
      {score}
    </span>
  )
}

ScorePill.propTypes = {
  score: PropTypes.number,
  color: PropTypes.string,
  emptyLabel: PropTypes.string,
  className: PropTypes.string
}

ScorePill.defaultProps = {
  score: undefined,
  color: undefined,
  emptyLabel: '–',
  className: undefined
}

export default ScorePill
